import { render, staticRenderFns } from "./DisputeCaseInformation.vue?vue&type=template&id=c50323f4&scoped=true"
import script from "./DisputeCaseInformation.vue?vue&type=script&lang=js"
export * from "./DisputeCaseInformation.vue?vue&type=script&lang=js"
import style0 from "./DisputeCaseInformation.vue?vue&type=style&index=0&id=c50323f4&prod&lang=scss&scoped=true"
import style1 from "./DisputeCaseInformation.vue?vue&type=style&index=1&id=c50323f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50323f4",
  null
  
)

export default component.exports